import device from '@/utils/device'
export default {
  computed: {
    isMobile (){
      return device==='mobile'
    }
  }
}